import { parseSafeInt } from "Backend";
import { LoaderFunctionArgs } from "react-router";
import { LoaderFunction, redirect } from "react-router-typesafe";
import { fetchTags } from "redux/slices/lensEditor";
import store from "redux/store";

export const tagsLoader = (async (args: LoaderFunctionArgs) => {
  const lensId = parseSafeInt(args.params.lensId);

  if (lensId === undefined) {
    return redirect("..");
  }

  return store.dispatch(fetchTags({ lensId })).unwrap();
}) satisfies LoaderFunction;
